import BaseAPIClient from './base/BaseAPIClient';

export default class McpOAuthClient extends BaseAPIClient {
  getConsentData(encodedData) {
    return this._get('mcp/oauth/consent', { data: encodedData });
  }

  submitConsent({ consent_data, company_id, approved }) {
    return this._post('mcp/oauth/consent', {
      consent_data,
      company_id,
      approved,
    });
  }
}
